module.exports = __webpack_public_path__ + "img/icon-cloud.727a4189.svg";